import { RedoIncrementDecrement } from "@redotech/redo-web/arbiter-components/increment-decrement/redo-increment-decrement";
import { RedoExternalLink } from "@redotech/redo-web/arbiter-components/links/redo-external-link";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { memo } from "react";
export const posGeneralForm = groupInput({
  defaultPosRestock: input<boolean>(),
  chargeAmountPerReturn: input<number>(),
  sendOnlyCompletionEmail: input<boolean>(),
  allowPOSAdjustments: input<boolean>(),
  allowPOSManualDiscounts: input<boolean>(),
});

export type PosGeneralForm = InputSchema.Input<typeof posGeneralForm>;

export type PosGeneralValue = InputSchema.Value<typeof posGeneralForm>;

export const posGeneralDefault: PosGeneralValue = {
  defaultPosRestock: true,
  chargeAmountPerReturn: 0,
  sendOnlyCompletionEmail: true,
  allowPOSAdjustments: true,
  allowPOSManualDiscounts: true,
};

export const PosGeneral = memo(function PosGeneral({
  posInput,
}: {
  posInput: PosGeneralForm;
}) {
  return (
    <Flex justify="center" w="full">
      <Flex flexDirection="column" gap="3xl" w="half">
        <Flex flexDirection="column" gap="lg">
          <Text fontSize="lg" fontWeight="bold" mb="md">
            General
          </Text>

          <RedoToggle
            description="The default restocking option when creating a POS return."
            label="Restock by default"
            setValue={function (value: boolean): void {
              posInput.inputs.defaultPosRestock.setValue(value);
            }}
            size="md"
            value={posInput.inputs.defaultPosRestock.value ?? true}
          />
          <RedoToggle
            description="When enabled, POS returns will only send the return completed email, skipping creation and label emails."
            label="Send only completion email for POS returns"
            setValue={function (value: boolean): void {
              posInput.inputs.sendOnlyCompletionEmail.setValue(value);
            }}
            size="md"
            value={posInput.inputs.sendOnlyCompletionEmail.value ?? true}
          />
          <RedoIncrementDecrement
            description={`We will charge ${posInput.inputs.chargeAmountPerReturn.value.toFixed(2)} per return (unless the customer bought return coverage)`}
            label="Charge amount per return"
            min={0}
            setValue={function (value: number): void {
              posInput.inputs.chargeAmountPerReturn.setValue(value);
            }}
            size="small"
            step={0.1}
            value={posInput.inputs.chargeAmountPerReturn.value}
          />
        </Flex>

        <Flex flexDirection="column" gap="md">
          <Text fontSize="lg" fontWeight="bold" mb="md">
            Getting started
          </Text>

          <RedoExternalLink
            fontSize="md"
            newTab
            text="Admin documentation and tutorials"
            url="https://www.notion.so/redotech/Shopify-POS-Admin-How-To-13f1a66084258027b2f6f20cad735d8b"
          />
          <RedoExternalLink
            fontSize="md"
            newTab
            text="Employee documentation and tutorials"
            url="https://www.notion.so/redotech/Shopify-POS-Employee-How-To-13f1a660842580dabefcf39121dfa48f"
          />
        </Flex>
      </Flex>
    </Flex>
  );
});
